<div #modal class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button id='memberDeleteModalDialogClose' type="button" class="close" data-dismiss="modal"
          aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h2 class="modal-title">Delete member {{ memberId }}</h2>
      </div>
      <div class="modal-body">
        Are you sure you want to delete this member?
        <div class="data-field">
          <input type="checkbox" id="gdpr-delete" name="gdpr-delete" #gdprDeleteCheckbox [(ngModel)]="gdprDelete" />
          <label for="gdpr-delete">GDPR delete</label>
        </div>
      </div>
      <div class='modal-actions'>
        <button id='memberDeleteModalDialogCancel' type="button" data-dismiss="modal" class="btn">Cancel</button>
        <button id='memberDeleteDialogOK' type="button" class="btn btn-primary" (click)="confirm()"
          [disabled]="loading">Confirm</button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/member/member-delete-dialog/member-delete-dialog.component.html